import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnchecked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		opacity: .5,
		cx: 10,
		cy: 10,
		r: 9.25,
		stroke: "#EF4444",
		strokeWidth: 1.5
	})
});
export default SvgUnchecked;
